// Copyright (c) 2018 Daniel Cousens
// Copyright (c) 2023 Bitcoin ABC
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
'use strict';
const { coinSelect, getMaxSendAmountSatoshis } = require('./src/coinSelect');
module.exports = { coinSelect, getMaxSendAmountSatoshis };
